/** Valeurs par défaut frontend (miroir backend) — repli hors ligne. */

export const DEFAULT_PUBLIC_PAGES_SETTINGS = {
  support: {
    banners: {
      maintenance: { enabled: false, severity: 'warning', messages: { fr: '', en: '', es: '' } },
      incident: { enabled: false, severity: 'error', messages: { fr: '', en: '', es: '' } }
    },
    resources: [],
    sla: []
  },
  privacy: {
    meta: { lastUpdated: '2026-02-17', effectiveDate: '2026-02-28', version: '1.0' },
    resources: [],
    sections: []
  }
};

export const pickLocaleText = (map, locale, fallbackLocale = 'fr') => {
  if (!map || typeof map !== 'object') return '';
  const loc = String(locale || 'fr').split('-')[0];
  return (
    map[loc] ||
    map[fallbackLocale] ||
    map.fr ||
    map.en ||
    map.es ||
    ''
  );
};

export const formatPrivacyDate = (isoDate, locale) => {
  const raw = String(isoDate || '').trim();
  if (!raw) return '';
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  try {
    return parsed.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return raw;
  }
};
